var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,4.5859375L4.7070312,3.2929688L3.2929688,4.7070312l2,2C5.4882812,6.9023438,5.7441406,7,6,7 s0.5117188-0.0976562,0.7070312-0.2929688l5-5l-1.4140625-1.4140625L6,4.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,12.5859375l-1.2929688-1.2929688l-1.4140625,1.4140625l2,2C5.4882812,14.9023438,5.7441406,15,6,15 s0.5117188-0.0976562,0.7070312-0.2929688l5-5l-1.4140625-1.4140625L6,12.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,20.5859375l-1.2929688-1.2929688l-1.4140625,1.4140625l2,2C5.4882812,22.9023438,5.7441406,23,6,23 s0.5117188-0.0976562,0.7070312-0.2929688l5-5l-1.4140625-1.4140625L6,20.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,28.5859375l-1.2929688-1.2929688l-1.4140625,1.4140625l2,2C5.4882812,30.9023438,5.7441406,31,6,31 s0.5117188-0.0976562,0.7070312-0.2929688l5-5l-1.4140625-1.4140625L6,28.5859375z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 27,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 16,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesSmall);
export default __webpack_public_path__ + "static/media/features--small.8c76c212fa7197aa88913da058ed6c27.svg";
export { ForwardRef as ReactComponent };